import type { AssistantActivity, PendingAction } from '@secretario/shared';
import { draftWasHandled } from './assistantDraft.js';

/**
 * A ação que o Secretário deixou esperando o sim (F0), na última fala dele: só a mais nova,
 * ainda no prazo e sem decisão neste aparelho. Reusa o registro dos rascunhos tratados.
 */
export function pendingAction(activities: AssistantActivity[]): PendingAction | null {
  for (let index = activities.length - 1; index >= 0; index -= 1) {
    const pending = activities[index]?.pending;
    if (!pending) continue;
    if (draftWasHandled(pending.id)) return null;
    if (Date.parse(pending.expiresAt) <= Date.now()) return null;
    return pending;
  }
  return null;
}
